export const LOADING = "LOADING";
export const STATUS_OK = "STATUS_OK";
export const UPDATE_SELECTED_COUNTRY = "UPDATE_SELECTED_COUNTRY";
export const UPDATE_FILTERS = "UPDATE_FILTERS";
